import { privacyPolicy } from "../../assets/dummyData";
import styles from "./TermsPrivacy.module.css";

function PrivacyPolicy() {
    return ( 
        <div className={styles.container} dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
     );
}

export default PrivacyPolicy;